import React, { useContext, useEffect } from 'react'
import { Button, Grid } from '@mui/material'
import PageLayout from 'common/Layout/Page/PageLayout'
import { ColorBoxContent } from 'common/ui/colorBox'
import JoyrideContext from 'context/joyride/joyrideContext'

// Placeholder generic component to select between faber and orbit versions of the same views
export default function FaberOrOrbit(props: IFaberOrOrbitProps) {
  const { pageHeader, orbitBtnOnClick, faberBtnOnClick } = props

  const joyrideContext = useContext(JoyrideContext)
  const { tourActive, setRun } = joyrideContext

  useEffect(() => {
    if (tourActive) {
      setTimeout(() => {
        setRun(true)
        // setStepIndex(6)
      }, 1000)
    }
  }, [])

  return (
    <PageLayout header={pageHeader}>
      <Grid
        id='shopfront__catalogSection'
        container
        spacing={2}
        columns={{ xs: 6, md: 12 }}
      >
        <Grid item xs={12} md={6}>
          <div id='shopfront__buyNewSimSection'>
            <ColorBoxContent
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <Button
                id='orbitBtn'
                variant='contained'
                aria-label='orbit'
                data-cy='orbitBtn'
                onClick={orbitBtnOnClick}
              >
                Orbit
              </Button>
            </ColorBoxContent>
          </div>
        </Grid>

        <Grid item xs={12} md={6}>
          <div id='shopfront__comingSoon'>
            <ColorBoxContent
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <Button
                id='faberBtn'
                variant='contained'
                aria-label='faber'
                data-cy='faber'
                onClick={faberBtnOnClick}
              >
                Faber
              </Button>
            </ColorBoxContent>
          </div>
        </Grid>
      </Grid>
    </PageLayout>
  )
}

interface IFaberOrOrbitProps {
  pageHeader: string
  orbitBtnOnClick: () => void
  faberBtnOnClick: () => void
}
